/**
 * Retry QuickBooks bill creation for a ready_to_pay supplier bill / PO.
 * Server-side idempotent callable — never creates a second bill if one exists.
 */

import { getFunctions, httpsCallable } from 'firebase/functions';
import { ensureAuth } from './firebase';

export type RetrySupplierBillQboBillResult = {
  success: boolean;
  status: string;
  reused?: boolean;
  qbBillId?: string | null;
  qbBillUrl?: string | null;
  message?: string;
  billId?: string;
};

export async function retrySupplierBillQboBill(input: {
  billId?: string | null;
  purchaseRequisitionId?: string | null;
}): Promise<RetrySupplierBillQboBillResult> {
  await ensureAuth();
  const fn = httpsCallable(getFunctions(undefined, 'us-central1'), 'retrySupplierBillQboBill');
  const res = await fn({
    billId: input.billId || undefined,
    purchaseRequisitionId: input.purchaseRequisitionId || undefined,
  });
  return res.data as RetrySupplierBillQboBillResult;
}
